'use strict';
import React, { Component } from 'react';
import ImporteCuotaColumn from './ImporteCuotaColumn'
import NumeroCuotaColumn from './NumeroCuotaColumn'
import TotalPendienteColumn from './TotalPendienteColumn'

class CuotasPendientesRow extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { cuotasPendientes, extension, moneda } = this.props;

        const consumoText = cuotasPendientes[0].RazonSocial;

        let numerosCuotaColumns = cuotasPendientes.map((cuotaPendiente) => {
            return <NumeroCuotaColumn CuotaNumero={cuotaPendiente.CuotaNumero} Cierre={cuotaPendiente.Cierre} />
        });

        let importesCuotaColumns = cuotasPendientes.map((cuotaPendiente) => {
            return <ImporteCuotaColumn Importe={cuotaPendiente.Importe} Cierre={cuotaPendiente.Cierre} />
        });

        return <tr>
            <td colSpan="8">
                <table style={{ width: "100%" }}>
                    <tr>
                        <td colSpan="8" style={{ backgroundColor: "#ebebeb" }}>
                            <label className="label-primary">{"TARJETA " + cuotasPendientes[0].Apellido + " " + cuotasPendientes[0].Nombre + " " + cuotasPendientes[0].TarjetaCreditoNumero}</label>
                        </td>
                    </tr>

                    <tr>
                        <td className="bordeado th-cierres-big lbl-nombre-consumo" rowSpan="2">
                            <label className="label-primary">{consumoText}</label>
                        </td>
                        <td>
                            <table style={{ width: "100%" }}>
                                <tr className="bordeado">
                                    <th className="bordeado th-cierres">
                                        <label className="label-primary">CUOTA</label>
                                    </th>
                                    {numerosCuotaColumns}
                                </tr>
                                <tr className="bordeado">
                                    <th className="bordeado th-cierres">
                                        <label className="label-primary">{moneda}</label>
                                    </th>
                                    {importesCuotaColumns}
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    }

}
export default CuotasPendientesRow;